// // import React, { useState } from 'react';
// // import Sidebar from '../Components/SideBar';
// // import Header from '../Components/Header';
// // import Footer from '../Components/Footer';

// // const MainLayout = ({ children }) => {
// //   const [sidebarOpen, setSidebarOpen] = useState(false);

// //   const toggleSidebar = () => {
// //     setSidebarOpen(!sidebarOpen);
// //   };

// //   return (
// //     <div className="flex h-screen overflow-hidden">
// //       {/* Sidebar */}
// //       <div
// //         className={`fixed inset-y-0 left-0 z-40 w-64 transition-transform duration-300 ease-in-out bg-gray-800 ${
// //           sidebarOpen ? 'translate-x-0' : '-translate-x-full'
// //         } sm:translate-x-0 sm:static`}
// //       >
// //         <Sidebar toggleSidebar={toggleSidebar} />
// //       </div>

// //       {/* Content */}
// //       <div className="flex flex-col flex-1 w-full min-h-screen bg-gray-50">
// //         <Header toggleSidebar={toggleSidebar} />
// //         <main className="flex-1 overflow-y-auto p-4">{children}</main>
// //         <Footer />
// //       </div>
// //     </div>
// //   );
// // };

// // export default MainLayout;

// // File: src/Layout/MainLayout.jsx
// import React, { useState } from 'react';
// import Sidebar from '../Components/SideBar';
// import Header from '../Components/Header';
// // import Footer from '../Components/Footer';
// import { Outlet } from 'react-router-dom';

// const MainLayout = () => {
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   return (
//     <div className="flex h-screen overflow-hidden">
//       {/* Sidebar */}
//       <div
//         className={`fixed inset-y-0 left-0 z-40 w-64 transition-transform duration-300 ease-in-out bg-gray-800 ${
//           sidebarOpen ? 'translate-x-0' : '-translate-x-full'
//         } sm:translate-x-0 sm:static`}
//       >
//         <Sidebar toggleSidebar={toggleSidebar} />
//       </div>

//       {/* Content */}
//       <div className="flex flex-col flex-1 w-full min-h-screen bg-gray-50">
//         <Header toggleSidebar={toggleSidebar} />
//         <main className="flex-1 overflow-y-auto">
//           <Outlet /> {/* This will render Purchase, Sales, etc. */}
//         </main>
//         {/* <Footer /> */}
//       </div>
//     </div>
//   );
// };

// export default MainLayout;


import React, { useState } from 'react';
import Sidebar from '../Components/SideBar';
import Header from '../Components/Header';
import { Outlet, } from 'react-router-dom';

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);



  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-40 w-64 transition-transform duration-300 ease-in-out bg-gray-800 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } sm:translate-x-0 sm:static`}
      >
        <Sidebar toggleSidebar={toggleSidebar} />
      </div>

      {/* Content */}
      <div className="flex flex-col flex-1 w-full min-h-screen bg-gray-50">
        {/* Header with Logout + User Info */}
        <Header toggleSidebar={toggleSidebar} />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
